"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CenteredGrid = void 0;

var tslib_1 = require("tslib");

var ui_grid_1 = require("@hopin-team/ui-grid");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.CenteredGrid = styled_components_1.default(ui_grid_1.Grid)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  height: 100%;\n"], ["\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  height: 100%;\n"])));
var templateObject_1;